import { Pick_Arr } from "../../../global-types";
import { Animals, AnimalTypes } from "./animalData";
import { Group } from "./animalGroups";
import { Condition } from "./conditions";
import { Location } from "./locations";

export type DataLevel = "locationId" | "groupId" | "animalId"

export type FilterParameter = { } & Partial<Pick_Arr<Animals, "animalType">> & Partial<Pick_Arr<Location, "locationId">> & Partial<Pick_Arr<Condition, "conditionId">> & Partial<Pick_Arr<Group, "groupId">>
export type DataParameter = keyof FilterParameter

export type ArchivedReport = {
    reportNo: number 
    name: string 
    dataLevel: DataLevel
    filterParameter?: {
      main:{key:Extract<keyof FilterParameter, string>, value:any}, //TODO: better typescript
      sub?:FilterParameter
    }[]
    dataParameter: DataParameter[]
    dateStart: string
    dateEnd?: string
  };

export const TestData: ArchivedReport[] = [
  {
    reportNo: 1,
    name: "Farrowing Unit Fat Condition",
    dataLevel: "animalId",
    filterParameter: [
      {main:{key:"locationId", value:1}, sub:{conditionId: [5, 4]}},
    ],
    dataParameter: [
      "groupId"
    ],
    dateStart: "24/12/24",
    dateEnd: "31/12/24"
  },
  {
    reportNo: 2,
    name: "Weaner Unit Skinny Condition",
    dataLevel: "animalId",
    filterParameter: [
      {main:{key:"locationId", value:2}, sub:{conditionId: [2, 3]}},
    ],
    dataParameter: [
      "groupId"
    ],
    dateStart: "24/12/24",
    dateEnd: "31/12/24"
  },
  {
    reportNo: 3,
    name: "All Normal Condition",
    dataLevel: "animalId",
    filterParameter: [
    ],
    dataParameter: [
      "groupId",
      "conditionId",
      "locationId",
    ],
    dateStart: "24/12/24",
    dateEnd: "31/12/24"
  }
]

// export type FilterParameter = {} & Partial<Pick<Location, "locationId">> & Partial<Pick<Condition, "conditionId">> & Partial<Pick<Group, "groupId">>


  // var test: ArchivedReport = {
  //   filterList: [{
  //     main:{key:"groupId", value:1, display:true},
  //     sub:{
  //       conditionId:[1,2],
  //       groupId
  //     }
  //   }]
  // }

    // {
  //   reportNo: 2,
  //   name: "Feed Plan and Condition Score",
  //   dataLevel: "Group",
  //   filterParameter: [
  //     {groupId: 1},
  //     {conditionId: 1}
  //   ],
  //   dataParameter: [
  //     "Location",
  //     "Group"
  //   ],
  //   dateStart: "12/06/23",
  //   dateEnd: "15/06/23"
  // },
  // {
  //   reportNo: 3,
  //   name: "Feed Plan",
  //   dataLevel: "Group",
  //   filterParameter: [
  //     {groupId: 2},
  //     {conditionId: 1}
  //   ],
  //   dataParameter: [
  //     "Location",
  //   ],
  //   dateStart: "23/10/24",
  // }